import React from 'react'
import { rem } from 'polished'
import cn from 'clsx'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import variables from 'styles/vendor/bootstrap/variables'

const ActionFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${rem(24)};
  gap: ${rem(16)};

  ${mediaQueryUp.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
  }
`

const StickyActionFooterContent = styled(LayoutContainer)`
  display: none;
`

const StickyActionFooter = styled.div`
  bottom: -${rem(80)};
  transition: bottom 0.2s;

  &.sticky {
    display: flex;
    align-items: center;
    position: sticky;
    bottom: 0;
    background-color: ${props => props.theme.palette.neutral.default.eight};
    box-shadow: ${props => props.theme.shadow.top.small};
    border-top: 1px solid ${props => props.theme.palette.neutral.default.five};
    padding: 0 ${rem(16)};
    min-height: ${rem(80)};
    z-index: 1;
    margin-right: -${rem(variables.gutterWidth / 2)};
    margin-left: -${rem(variables.gutterWidth / 2)};

    ${mediaQueryUp.desktop} {
      position: fixed;
      left: 0;
      width: 100%;
      padding: 0;
    }

    ${StickyActionFooterContent} {
      display: flex;
      flex-direction: column;
      padding: 0;
      gap: ${rem(16)};

      ${mediaQueryUp.desktop} {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
`

interface Props {
  children: React.ReactNode;
  sticky?: boolean;
}

const MultipleRoomsBookingContentFooter = React.forwardRef<HTMLDivElement, Props>(function(props, ref) {
  const { children, sticky } = props

  return (<>
    <ActionFooter ref={ref}>
      {children}
    </ActionFooter>
    <StickyActionFooter className={cn({ sticky })}>
      <StickyActionFooterContent>
        {children}
      </StickyActionFooterContent>
    </StickyActionFooter>
  </>)
})

export default MultipleRoomsBookingContentFooter
